module.exports = __webpack_public_path__ + "img/share-family.43d95941.jpg";